'use strict';

import angular from 'angular';
import template from './modal.pug';

const MemModalDeactivateSvc = [
  '$filter',
  'ModalSvc',
  'LoaderSvc',
  'DatetimeSvc',
  'MemberSvc',
  'GroupSvc',
  'moment',
  function(
    $filter,
    ModalSvc,
    LoaderSvc,
    DatetimeSvc,
    MemberSvc,
    GroupSvc,
    moment
  ) {
    /**
     * Opens the groupRole Modal
     * @param  {Object} currentGrpRle   - currentPos
     * @return {Object}                 - the updated pos instance
     */
    function open(groupId, personId) {
      var modalInstance;
      var datemodelvm = {end: moment()};
      datemodelvm = DatetimeSvc.getFormDateRange(datemodelvm); // set form dates
      var modalvm = {};

      modalvm.title = 'Mark Member Inactive';
      modalvm.today = new Date();

      // datepicker
      modalvm.dateFormat = 'M/d/yyyy';
      modalvm.openActive = function($event, dateType) {
        $event.preventDefault();
        $event.stopPropagation();
        modalvm.formvm[dateType + 'Open'] = true;
      };

      // provide option to end in prior time period/year (avoids fees)
      /**
       * TODO: add time period end option to position and member edit modals
       */
      modalvm.setEndText = 'Set End Date to Prior Time Period';
      var timePeriods = [];
      GroupSvc.getTimePeriods({groupId}).$promise.then(function(tp) {
        for(var i = 0; i < tp.length; i++) {
          if(DatetimeSvc.rangeToString(tp[i]).indexOf('Past') >= 0) {
            timePeriods.push(tp[i]);
          }
        }
        timePeriods = $filter('orderBy')(timePeriods, 'start', true);
        modalvm.setEnd = function() {
          var endStr = DatetimeSvc.parseUTCDate(timePeriods[0].end);
          modalvm.datemodelvm.formEnd = new Date(endStr);
        };
      });


      // submit
      function onSubmit() {
        modalvm.submitted = true; // modal submits outside of form
        if(modalvm.formvm.$valid) {
          LoaderSvc.start();
          // set dates from form values
          DatetimeSvc.setDatesBasedOnForm(datemodelvm);

          MemberSvc.deactivate({groupId, id: personId}, datemodelvm).$promise
            .then(function() {
              LoaderSvc.stopSuccess('Member Marked Inactive');
              modalInstance.close();
            });
        }
      }

      function onCancel() {
        modalInstance.dismiss();
      }

      var modalScope = {modalvm: angular.extend(modalvm, {
        dismissable: true,
        datemodelvm,
        onSubmit,
        buttons: [
          {classes: 'btn-primary', text: 'Mark Inactive', click: onSubmit},
          {classes: 'btn-default', text: 'Cancel', click: onCancel}
        ]
      })};

      var options = {template};

      modalInstance = ModalSvc.open(modalScope, options);
      return modalInstance.result;
    }

    // Public API here
    return {
      open
    };
  }
];

export default MemModalDeactivateSvc;
